import React from 'react';
import { Form, Select } from 'antd';
import { Field, ToggleField } from '@src/components/Common/Form';
import { SchemaControl } from '@src/components/AIProcessors/SchemaField';

const STAGE_OPTIONS = [
    { value: 'config', label: 'Config' },
    { value: 'verify', label: 'Verify' },
    { value: 'execution', label: 'Execution' },
];

/**
 * What a pipeline processor is given, and what it may answer with. Every field
 * here lives under `extra_data`, so the API takes the whole group as one object.
 */
const PackForm = ({ disabled }: { disabled?: boolean }) => {
    const form = Form.useFormInstance();
    const generativeUI = Form.useWatch(['extra_data', 'enable_generative_ui'], form);

    return (
        <>
            <ToggleField
                name={['extra_data', 'include_change_instance']}
                span={3}
                label="Include change instance"
                hint="Sends the last change instance for the item."
            />
            <ToggleField
                name={['extra_data', 'enable_pack_context']}
                span={3}
                label="Enable pack context"
                hint="Sends the Pack documents with the payload."
            />
            <ToggleField
                name={['extra_data', 'include_previous_declaration']}
                span={3}
                label="Include previous declaration"
                hint="Sends the item's previous declaration."
            />
            <ToggleField
                name={['extra_data', 'include_service_config']}
                span={3}
                label="Include service config"
                hint="Sends the latest service config JSON."
            />

            <Field
                name={['extra_data', 'include_previous_pipeline_data']}
                label="Carry over stages"
                span={3}
                hint="Stages of the last pipeline to reuse on a retrigger."
            >
                <Select mode="multiple" allowClear placeholder="Select stages" options={STAGE_OPTIONS} />
            </Field>

            <ToggleField
                name={['extra_data', 'enable_generative_ui']}
                span={3}
                label="Enable generative UI"
                hint="The model answers with UI components."
            />

            {generativeUI && (
                <Field
                    name={['extra_data', 'generative_ui_schema']}
                    label="Generative UI schema"
                    span={3}
                    hint="The shape those components follow."
                >
                    <SchemaControl label="generative UI schema" disabled={disabled} />
                </Field>
            )}
        </>
    );
};

export default PackForm;
